/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { BANNER_VIEW, GA4_EVENT_VIEW_BANNER, PAGE_DATA_LAYER } from '@/data/constants/gtm';
import { getGTMBannerViewEventData } from '@/data/events/data/gtm/BannerView';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMBannerViewPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (data: Awaited<ReturnType<typeof getGTMBannerViewEventData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: GA4_EVENT_VIEW_BANNER,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const measure_UA = async (data: Awaited<ReturnType<typeof getGTMBannerViewEventData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: BANNER_VIEW,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const sendGTMBannerViewEvent = async (payload: GTMBannerViewPayload) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = await getGTMBannerViewEventData(payload);
		if (ua) {
			try {
				await measure_UA(data);
			} catch (error) {
				logError(undefined, 'BannerView: sendGTMBannerViewEvent: measure_UA: error: %o', error);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(data);
			} catch (error) {
				logError(undefined, 'BannerView: sendGTMBannerViewEvent: measure_GA4: error: %o', error);
			}
		}
	}
};
